import { Pressable, StyleSheet, TouchableOpacity, View } from 'react-native'
import React, { Dispatch, SetStateAction, useState } from 'react'
import { ZenIcon, ZenText } from 'zen-core-elements'
import { CustomModal } from '../../../shared/commonComponents/customModal'
import { Theme, ThemeConsumer } from '@rneui/themed'

export type SellScreenParkRemoveOptions = "removeCustomer" | "parkSale" | "clearCartRemoveCustomer" | "clearCartParkSale" | null

interface RadioGroupType {
    radioBtn1: { id: SellScreenParkRemoveOptions, title: string, subText: string },
    radioBtn2: { id: SellScreenParkRemoveOptions, title: string, subText: string },
}

const SwitchRemoveCustomerModal = ({ visible, onClose, isDestructive, onSuccess, radioGroup, mainText, subText, selectedOption, setSelectedOption }: { visible: boolean, onClose: () => void, isDestructive?: boolean, onSuccess: () => void, radioGroup: RadioGroupType, mainText: string, subText: string, selectedOption: SellScreenParkRemoveOptions, setSelectedOption: Dispatch<SetStateAction<SellScreenParkRemoveOptions>> }) => {


    const RadioOption = ({ id, title, subtext }: { id: SellScreenParkRemoveOptions, title: string, subtext: string }) => (
        <ThemeConsumer>
            {({ theme }) => {
                const styles = style(theme)
                return (
                    <Pressable
                        style={styles.optionContainer}
                        onPress={() => setSelectedOption(id)}
                    >
                        <ZenIcon type='material-community'
                            name={selectedOption === id ? "radiobox-marked" : "radiobox-blank"}
                            size={24}
                            color={selectedOption === id ? "#2B64E3" : "#C4C4C4"}
                        />
                        <View style={styles.textContainer}>
                            <ZenText content={title} color='#1A1C1E' size={theme.tinyFontSize} />
                            <ZenText content={subtext} color='#9CA3AF' size={theme.errorFontSize} style={styles.optionSubtext} />
                        </View>
                    </Pressable>
                )
            }}
        </ThemeConsumer>
    );
    return (
        <ThemeConsumer>
            {({ theme }) => {
                const styles = style(theme)

                return (
                    <CustomModal
                        transparent={true}
                        visible={visible}
                        animationType="fade"
                        onRequestClose={onClose}
                    >
                        <View style={styles.overlay}>
                            <View style={styles.card}>
                                {/* Top User Icon */}
                                <View style={[styles.userIconContainer, { backgroundColor: isDestructive ? "#FFEBEE" : "#EFF4FF" }]}>
                                    <ZenIcon type='material-community' name={isDestructive ? "account-remove-outline" : "account-plus-outline"} size={30} color={isDestructive ? "#F44336" : "#2B64E3"} />
                                </View>

                                {/* Header Text */}
                                <ZenText content={mainText} bold color='#1A1C1E' style={styles.mainTitle} size={theme?.mediumFontSize} />
                                <ZenText content={subText} style={styles.subTitle} color='#6B7280' size={theme.smallHeaderFontSize} />

                                {/* Selection Options */}
                                <View style={styles.optionsList}>
                                    <RadioOption
                                        id={radioGroup?.radioBtn1?.id}
                                        title={radioGroup?.radioBtn1?.title}
                                        subtext={radioGroup?.radioBtn1?.subText}
                                    />
                                    <RadioOption
                                        id={radioGroup?.radioBtn2?.id}
                                        title={radioGroup?.radioBtn2?.title}
                                        subtext={radioGroup?.radioBtn2?.subText}
                                    />
                                </View>

                                {/* Action Buttons */}
                                <View style={styles.buttonRow}>
                                    <TouchableOpacity style={styles.cancelButton} onPress={onClose}>
                                        <ZenText content="Cancel" color='#374151' size={theme.tinyFontSize} bold />
                                    </TouchableOpacity>
                                    <TouchableOpacity style={[styles.continueButton, { backgroundColor: isDestructive ? "#F44336" : "#2B64E3" }]} onPress={onSuccess}>
                                        <ZenText content={isDestructive ? "Remove" : "Continue"} color={theme.light} size={theme.tinyFontSize} bold />
                                    </TouchableOpacity>
                                </View>
                            </View>
                        </View>
                    </CustomModal>
                )
            }}
        </ThemeConsumer>
    )
}

export default SwitchRemoveCustomerModal

const style = (theme: Theme) => StyleSheet.create({
    overlay: {
        flex: 1,
        backgroundColor: 'rgba(0, 0, 0, 0.4)',
        justifyContent: 'center',
        alignItems: 'center'
    },
    card: {
        width: '90%',
        maxWidth: 600,
        backgroundColor: theme.light,
        borderRadius: 16,
        padding: 24,
        alignItems: 'center',
        // Shadow for iOS/Android
        shadowColor: "#000",
        shadowOffset: { width: 0, height: 4 },
        shadowOpacity: 0.1,
        shadowRadius: 10,
        elevation: 5,
    },
    userIconContainer: {
        width: 60,
        height: 60,
        borderRadius: 30,
        backgroundColor: '#EFF4FF',
        justifyContent: 'center',
        alignItems: 'center',
        marginBottom: 16,
    },
    mainTitle: {
        textAlign: 'center',
    },
    subTitle: {
        marginTop: 4,
        marginBottom: 24,
        textAlign: 'center',
    },
    optionsList: {
        width: '100%',
        marginBottom: 30,
    },
    optionContainer: {
        flexDirection: 'row',
        alignItems: 'flex-start',
        marginBottom: 20,
    },
    textContainer: {
        marginLeft: 12,
        flex: 1,
    },
    optionSubtext: {
        marginTop: 2,
        lineHeight: 18,
    },
    buttonRow: {
        flexDirection: 'row',
        justifyContent: 'flex-end',
        width: '100%',
        gap: 12,
    },
    cancelButton: {
        paddingVertical: 12,
        paddingHorizontal: 30,
        borderRadius: 12,
        borderWidth: 1,
        borderColor: '#D1D5DB',
    },
    continueButton: {
        paddingVertical: 12,
        paddingHorizontal: 30,
        borderRadius: 12,
        backgroundColor: '#2B64E3',
    }
})